//PAGE
import React from 'react';
import PageContent from '../components/layouts/PageContent';
import { FileUploadDetails } from '../components/neighbor-tools/FileUploadDetails';

// File Upload Details Page Content
function NeighborTools() {

    //page content
    return (
        <PageContent
            bodyColor='#fff'
            expanded
        >
            <FileUploadDetails />
        </PageContent>
    );
}

export default NeighborTools;
